// Inside CartModal.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';

function CartModal({ showModal, handleCloseModal, modalImage, designShade }) {
  return (
    <Modal show={showModal} onHide={handleCloseModal} centered>
       <button
        onClick={handleCloseModal}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "-20px",
          right: "0",
          border: "1px solid rgb(146 141 141)",
          background: "#FFF",
          width: "31px",
          height: "31px",
          borderRadius: "20px"
        }}
      >
      <i className="bi bi-x-lg"></i>
      </button>
      
      <Modal.Body className="text-center">
        <img
          src={modalImage}
          alt="Preview"
          style={{ width:"80%", margin: "0 auto" }}
        />
        <h2 style={{ textAlign:"center", fontSize: "17px"}}> {designShade} </h2>
      </Modal.Body>
    </Modal>
  );
}
export default CartModal;
